import React, { useEffect, useState } from "react"
import { RowModule } from "../../../../component/atoms/RowModule/RowModule"
import AreaRegisteredNoteView from "./AreaRegisteredNoteView"
import {
  AREA_REGISTERED_ACTIVE_TAB_ENUM,
  SUB_MENU_REGISTERED
} from "../../../../constants/StringConstant"
import { getKeyFromValue } from "../../../helpers/Utils"

const SubMenuFilter = ({ onClick, initialActive }) => {
  const [subTabActive, setSubTabActive] = useState(initialActive)

  const onClickHandler = (data) => {
    setSubTabActive(data)
    onClick(getKeyFromValue(data, AREA_REGISTERED_ACTIVE_TAB_ENUM))
  }

  useEffect(() => {
    setSubTabActive(initialActive)
  }, [initialActive])

  return (
    <>
      <RowModule>
        <div className="d-flex w-100 align-items-center justify-content-start" style={{ gap: 8 }}>
          {Object.keys(SUB_MENU_REGISTERED).map((item, i) => {
            return (
              <div key={i} className={"d-flex align-items-center"}>
                <button
                  type="button"
                  className={`btn ${
                    subTabActive === AREA_REGISTERED_ACTIVE_TAB_ENUM[item]
                      ? "btn-outline-primary-rounded-active"
                      : "btn-outline-default-rounded"
                  } mr-2`}
                  onClick={() => onClickHandler(AREA_REGISTERED_ACTIVE_TAB_ENUM[item])}>
                  {SUB_MENU_REGISTERED[item]}
                </button>
              </div>
            )
          })}
        </div>
      </RowModule>
      <AreaRegisteredNoteView tab={subTabActive} />
    </>
  )
}

export default SubMenuFilter
